import { render, staticRenderFns } from "./EditIcon.vue?vue&type=template&id=10731d30&scoped=true"
import script from "./EditIcon.vue?vue&type=script&lang=js"
export * from "./EditIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10731d30",
  null
  
)

export default component.exports